import { Typography } from "antd"
import React from "react"

import "./styles.less"

const { Text } = Typography
const PrivacyPolicy = () => {
  return (
    <Text type="secondary" className="privacy-policy-block">
      © {new Date().getFullYear()} Ezbuild. All Rights Reserved
    </Text>
    /*<Text type="secondary" className="privacy-policy-block">
      By signing up, you agree to our <a href="#/privacy-policy"
                                         target="_blank"
                                         rel="noopener noreferrer"
    >
      Privacy Policy
    </a> and <a href="#/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
    >
      Terms & Conditions
    </a>
    </Text>*/
  )
}

export default PrivacyPolicy
